import { AttributeType } from "@evergis/api";

import { ImportAttribute } from "../components/Dialogs/Import/types";
import { DEFAULT_ID_ATTRIBUTE_NAME } from "../evergis/constants";
import { createUniqueNameObject } from "../components/Dialogs/Aggregation/utils/createUniqueNameObject";

export const createGidColumn = (attributes: ImportAttribute[], srid: number) => {
  const gidColumn = {
    name: DEFAULT_ID_ATTRIBUTE_NAME,
    attributeName: DEFAULT_ID_ATTRIBUTE_NAME,
    type: AttributeType.Int64,
    srid,
  };

  const newIdAttribute = createUniqueNameObject(
    gidColumn,
    attributes.map(({ name }) => name),
    "name",
  );

  gidColumn.name = newIdAttribute.name;
  gidColumn.attributeName = newIdAttribute.name;

  return gidColumn;
};
